<template>
  <transition name="fade">
    <section class="info" v-if="show">
      <img
          src="../images/utils/close.svg"
          alt="Закрыть"
          class="info__hide"
          @click="hideSelf"
      />
      <h2 class="info__title">
        Уважаемые члены клуба!<br><br>

        <b>Поздравляем с Новым Годом и Рождеством!</b>
        <br><br>Информируем вас об изменении графика работы нашего клуба в праздничные дни:
        <br>31.12 – с 07:00 до 18:00
        <br>1.01 – <b>выходной день</b>
        <br>Со 2.01 – 08.01 – в штатном режиме

        <br><br>С уважением, команда ФитнесМании
      </h2>
    </section>
  </transition>
</template>

<script>
export default {
  name: "notification-bar",
  data() {
    return {
      show: true,
    };
  },
  methods: {
    hideSelf() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.info {
  position: fixed;
  left: 1vw;
  bottom: 1vw;
  max-width: 400px;
  padding: 30px;
  background-color: $primary;
  color: #000000;
  //text-shadow: 1px 1px 1px #000;
  box-shadow:  0px 0px 10px #444;
  border-radius: 10px;
  z-index: 99;

  &__hide {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    filter: drop-shadow(1px 1px 2px #777);
  }

  &__title {
    font-size: 14px;
    line-height: 20px;
    font-weight: normal;

    span {
      font-weight: bold;
    }
  }
}

@media (max-width: 640px) {
  .info {
    max-width: 100%;
    right: 1vw;
    padding: 30px 20px;

    &__title {
      font-size: 12px;
      line-height: 17px;
    }
  }
}
</style>
